import { createAction } from '@reduxjs/toolkit';

export const shopUpdateId = createAction('shop/updateId');
export const shopUpdateUID = createAction('shop/updateUid');
export const shopUpdateSID = createAction('shop/updateSid');
export const shopUpdateIsAdded = createAction('shop/updateIsAdded');
export const shopUpdateIsActive = createAction('shop/updateIsActive');

export const shopStore = createAction('shop/store');
export const shopClear = createAction('shop/clear');

export const shopUpdateRequest = createAction('shop/updateRequest');
export const shopUpdateError = createAction('shop/updateError');
export const shopUpdateStore = createAction('shop/updateStore');

export const shopUpdateItems = createAction('shop/updateItems');
export const shopUpdateLists = createAction('shop/updateLists');

export const shopUpdatePostLayout = createAction('shop/updatePostLayout');
export const shopUpdatePostBackgroundColor = createAction('shop/updatePostBackgroundColor');
export const shopUpdatePostTextColor = createAction('shop/updatePostTextColor');
export const shopUpdatePostShadow = createAction('shop/updatePostShadow');
export const shopUpdatePostShadowColor = createAction('shop/updatePostShadowColor');
export const shopUpdatePostButtonBackgroundColor = createAction('shop/updatePostButtonBackgroundColor');
export const shopUpdatePostButtonTextColor = createAction('shop/updatePostButtonTextColor');

export const shopUpdateIsPostFavourite = createAction('shop/updateIsPostFavourite');
export const shopUpdateIsPostCart = createAction('shop/updateIsPostCart');
export const shopUpdateIsPostShadow = createAction('shop/updateIsPostShadow');
export const shopUpdateIsDisplayCart = createAction('shop/updateIsDisplayCart');
export const shopUpdateIsDisplayAvailable = createAction('shop/updateIsDisplayAvailable');
export const shopUpdateDefaultButtonTitle = createAction('shop/updateDefaultButtonTitle');
export const shopUpdateIsDisplayCategory = createAction('shop/updateIsDisplayCategory');
export const shopUpdateIsDisplaySearch = createAction('shop/updateIsDisplaySearch');
export const shopUpdateIsDisplaySort = createAction('shop/updateIsDisplaySort');
export const shopUpdateIsDisplayCrossSale = createAction('shop/updateIsDisplayCrossSale');

export const shopUpdateCategories = createAction('shop/updateCategories');
export const shopUpdateProperties = createAction('shop/updateProperties');
export const shopUpdateLabels = createAction('shop/updateLabels');

export const shopUpdateIsShippingName = createAction('shop/updateIsShippingName');
export const shopUpdateIsShippingPhone = createAction('shop/updateIsShippingPhone');
export const shopUpdateIsShippingEmail = createAction('shop/updateIsShippingNEmail');
export const shopUpdateIsShippingAddress = createAction('shop/updateIsShippingAddress');
export const shopUpdateIsShippingComment = createAction('shop/updateIsShippingComment');

export const shopUpdateIsShippingNameRequired = createAction('shop/updateIsShippingNameRequired');
export const shopUpdateIsShippingPhoneRequired = createAction('shop/updateIsShippingPhoneRequired');
export const shopUpdateIsShippingEmailRequired = createAction('shop/updateIsShippingNEmailRequired');
export const shopUpdateIsShippingAddressRequired = createAction('shop/updateIsShippingAddressRequired');
export const shopUpdateIsShippingCommentRequired = createAction('shop/updateIsShippingCommentRequired');

export const shopUpdateShippingFields = createAction('shop/updateShippingFields');

export const shopUpdateLayout = createAction('shop/updateLayout');
export const shopUpdateView = createAction('shop/updateView');
export const shopUpdateListView = createAction('shop/updateListView');

export const shopUpdateTitle = createAction('shop/updateTitle');
export const shopUpdateDescription = createAction('shop/updateDescription');
export const shopUpdateTextAlign = createAction('shop/updateTextAlign');
export const shopUpdateImage = createAction('shop/updateImage');
export const shopUpdateHeadingDivider = createAction('shop/updateHeadingDivider');

export const shopUpdateSectionIsBackground = createAction('shop/updateSectionIsBackground');
export const shopUpdateSectionTextColor = createAction('shop/updateSectionTextColor');
export const shopUpdateSectionBackgroundColor = createAction('shop/updateSectionBackgroundColor');
export const shopUpdateSectionOpacity = createAction('shop/updateSectionOpacity');
export const shopUpdateSectionIsFullWidth = createAction('shop/updateSectionIsFullWidth');
export const shopUpdateSectionShadow = createAction('shop/updateSectionShadow');
export const shopUpdateSectionShadowColor = createAction('shop/updateSectionShadowColor');
export const shopUpdateSectionPadding = createAction('shop/updateSectionPadding');
export const shopUpdateSectionMargin = createAction('shop/updateSectionMargin');
export const shopUpdateSectionBackgroundType = createAction('shop/updateSectionBackgroundType');
export const shopUpdateSectionBackgroundImage = createAction('shop/updateSectionBackgroundImage');
export const shopUpdateSectionGradientColor1 = createAction('shop/updateSectionGradientColor1');
export const shopUpdateSectionGradientColor2 = createAction('shop/updateSectionGradientColor2');
export const shopUpdateSectionGradientDirection = createAction('shop/updateSectionGradientDirection');
export const shopUpdateSectionGradientOffset = createAction('shop/updateSectionGradientOffset');
export const shopUpdateSectionBorder = createAction('shop/updateSectionBorder');
export const shopUpdateSectionBorderColor = createAction('shop/updateSectionBorderColor');
export const shopUpdateSectionShadowBorderColor = createAction('shop/updateSectionShadowBorderColor');
export const shopUpdateSectionShape = createAction('shop/updateSectionShape');
